import { Injectable } from '@angular/core';
import { SettingsService } from '../settings/settings.service';

type CaptchaAction = 'REQUEST_SMS' | 'LOGIN' | 'FORGOT_PASSWORD';


declare const grecaptcha: any;

@Injectable({ providedIn: 'root' })
export class CaptchaService {
  constructor(private settingsService: SettingsService) {}

  public getLoginCaptcha() {
    return this.getCaptcha('LOGIN');
  }

  public getRequestSMSCaptcha() {
    return this.getCaptcha('REQUEST_SMS');
  }

  public getForgotPasswordCaptcha() {
    return this.getCaptcha('FORGOT_PASSWORD');
  }

  private async getCaptcha(action: CaptchaAction) {
    const siteKey = this.settingsService.getConfigurationKeyValue(
      'enterpriseRecaptchaSiteKey'
    );
    const token = await grecaptcha.enterprise.execute(siteKey, { action });

    return {
      token,
      action,
      siteKey,
      asHeaders: () => ({
        'x-type': 'enterprise',
        'x-action': action,
        'x-captcha': token,
        'x-captcha-sitekey': siteKey
      })
    };
  }
}
